/**
 * @file claim-search-detail-response.interface.ts
 */
import { Ingredient } from './ingredient.interface';
import { Drug } from './drug.interface';
import { Pricing } from './pricing.interface';
import { Claim } from './claim.interface';
// import { Status } from './status.interface';
// export interface ClaimSearchDetailsResponse {
//   cardId: string;
//   claim: Claim;
//   clientId: string;
//   clientName: string;
//   compoundIngredients: Ingredient[];
//   drug: Drug;
//   firstName: string;
//   gender: string;
//   lastName: string;
//   pharmacyReimbursement: Pricing;
//   pricingInformation: Pricing;
//   status: Status;
// }

// export interface ClaimSearchDetailsResponse {
//   clientID: string;
//   clientName: string;
//   groupID: number;
//   groupName: string;
//   cardID: string;
//   name: string;
//   gender: 'M' | 'F';
//   DOB: string;
//   personCode: string;
//   relationshipCode: string;
//   copay: number;
//   patientPay: number;
//   claimID: number;
//   processDate: string;
//   rxNumber: string;
//   rxFillDate: string;
//   fillNumber: string;
//   writtenDate: string;
//   quantityPrescribed: number;
//   quantityDispensed: number | null;
//   compound: number;
//   DAW: string | null;
//   daysSupply: number;
//   pharmacy: string;
//   pharmacyNPI: string;
//   pharmacyAddress: string;
//   prescription: string;
//   PrescriberNPI: string;
//   Prescriber: string;
//   fillDate: string;
//   medication: string;
//   brandGeneric: 'B' | 'G';
//   routeofAdmin: string;
//   multisourceCode: 'M' | 'O' | 'N' | 'Y';
//   NDC: string;
//   specialty: string | null;
//   formularyTier: string;
//   maintenance: '0' | '1' | '2';
//   priorAuthList: string | null;
//   steptherapyProtocol: string | null;
//   quantityLimitList: string | null;
//   equivalentMedication: string | null;
//   therapeuticAlternativeMedications: string | null;
//   indication: string;
//   primaryDrugCategory: string | null;
//   additionalDrugCategories: string[] | null;
//   status: 'R' | 'AR' | 'AP' | 'AA';
//   processedAsPrimary: boolean;
//   additionalMessage: string[];
//   rejectCode: string;
//   rejectCodeDescription: string | null;
//   planAmount: number;
//   totalMemberResponsibility: number | null;
//   thirdPartAssistance: number | null;
//   totalMemberPay: number | null;
//   memberCopay: number | null;
//   memberDeductible: number | null;
//   memberOutOfPocket: number | null;
//   ancillaryCharge: number | null;
//   ingredientCost: number | null;
//   dispensingFee: number | null;
//   shippingCharge: number | null;
//   salesTax: number | null;
//   incentiveAmount: number | null;
//   totalCost: number | null;
//   pricingSourceUsed: string | null;
//   AWP: number | null;
//   pharmacyReimbursement: PharmacyReimbursementInterface;
// }

export interface ClaimSearchDetailsResponse {
  clientId: string;
  clientName: string;
  groupId: number;
  groupName: string;
  cardId: string;
  name: string;
  gender: 'M' | 'F' | null | string;
  dob: string;
  personCode: string;
  relationshipCode: string;
  claimId: string;
  processDate: string;
  rxNumber: string;
  rxFillDate: string;
  fillNumber: string;
  writtenDate: string;
  quantityPrescribed: number;
  quantityDispensed: number | null;
  compound: string | null;
  daw: string | null;
  daysSupply: number | null;
  pharmacy: string;
  pharmacyNPI: string;
  pharmacyAddress: string;
  prescription: string;
  pharmacyPhoneNumber: string;
  pharmacyStoreNumber: string;
  prescriberNPI: string;
  prescriber: string;
  medication: string;
  brandGeneric: 'B' | 'G' | 'T' | null | string;
  routeOfAdmin: string;
  multiSourceCode: 'M' | 'O' | 'N' | 'Y' | null | string;
  ndc: string;
  specialty: string;
  formularyTier: string;
  maintenance: '0' | '1' | '2' | null | string;
  priorAuthList: string;
  steptherapyProtocol: string | null;
  quantityLimitList: string | null;
  equivalentMedication: string | null;
  therapeuticAlternativeMedications: string | null;
  indication: string | null;
  primaryDrugCategory: string;
  additionalDrugCategories: string | null;
  status: string;
  processedAsPrimary: string;
  additionalMessage: string | null;
  rejectCode: string;
  rejectCodeDescription: string | null;
  planAmount: number | null;
  totalMemberResponsibility: number | null;
  thirdPartAssistance: string | null;
  totalMemberPay: number | null;
  memberCopay: number | null;
  memberDeductible: number | null;
  memberOutOfPocket: number | null;
  ancillaryCharge: string | number | null;
  ingredientCost: number | null;
  dispensingFee: number | null;
  shippingCharge: string | null;
  salesTax: number | null;
  incentiveAmount: number | null;
  totalCost: number | null;
  pricingSourceUsed: string;
  awp: number | null;
  pharmacyReimbursement: PharmacyReimbursementInterface | null;
  authNum?: string
}

export enum Gender {
  Male = 'M',
  Female = 'F',
}

export enum BrandGeneric {
  Brand = 'B',
  Generic = 'G',
}

export enum MultiSourceCode {
  SingleSourceCoLicensedProductBrand = 'M',
  MultiSourceOriginatorProductBrand = 'O',
  SingleSourceProductBrand = 'N',
  MultiSourceProductGeneric = 'Y',
}

// export enum Maintenance {
//   Undetermined = '0',
//   NotMaintenanceDrug = '1',
//   MaintenanceDrug = '2',
// }
export enum Maintenance {
  No = '0',
  Yes = '2',
}

export enum IStatus {
  Rejected = 'R',
  AcceptedReversal = 'AR',
  AcceptedPaid = 'AP',
  AllAcceptedClaims = 'AA',
}

export interface PharmacyReimbursementInterface {
  totalMemberResponsibility: number | null;
  thirdPartAssistance: number | null;
  totalMemberPay: number | null;
  memberCopay: number | null;
  memberDeductible: number | null;
  memberOutOfPocket: number | null;
  ancillaryCharge: number | null;
  ingredientCost: number | null;
  dispensingFee: number | null;
  shippingCharge: number | null;
  salesTax: number | null;
  incentiveAmount: number | null;
  totalCost: number | null;
  pricingSourceUsed: string | null;
  AWP: number | null;
}

export interface ClaimSearchCompareDetailsResponse {
  claim1: ClaimSearchDetailsResponse;
  claim2: ClaimSearchDetailsResponse;
}

export interface ThirdPartyAssistanceCompareResponseInterface {
  thirdParty1: ThirdPartyAssistanceResponseInterface;
  thirdParty2: ThirdPartyAssistanceResponseInterface;
}

export interface ClaimRequestInterface {
  patientId: string;
  claimId: string;
  clientId: string;
  authNum: string;
  migrationFlag?: string;
  accessLevel?: string;
  empirxMemberId?: string; //  Required for third party assistance API call
  cardId?: string; // Required for third party assistance API call
}

export interface ThirdPartyAssistanceResponseInterface {
  thirdPartyAssistance: string;
}
